import {arenaStyles} from "../../layouts/arena-layout/arena.css";
import {XCol, XText} from "@cdx/common";

const NotFound = () => (
  <XCol className={arenaStyles.outer} bg="gray700" align="center" justify="center" sp={2}>
    <XText color="gray100" preset="bold" size={7}>
      404
    </XText>
    <XText color="gray400" preset="bold" size={4}>
      Nothing found
    </XText>
  </XCol>
);

export default NotFound;
